import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ZipFileSvg = function ZipFileSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6356F6",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.167 7.833h1.666c.46 0 .834-.373.834-.833V5.333a.833.833 0 0 0-.834-.833h-1.666a.833.833 0 0 0-.834.833V7c0 .46.373.833.834.833M11.167 12h1.666c.46 0 .834-.373.834-.834V9.5a.833.833 0 0 0-.834-.834h-1.666a.833.833 0 0 0-.834.834v1.666c0 .46.373.834.834.834"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.991 12.834a2.5 2.5 0 0 0-2.457 2.039l-.53 2.978.008.104a1.664 1.664 0 0 0 1.663 1.545l2.975-.029.1-.026a1.663 1.663 0 0 0 1.213-1.919l-.497-2.653a2.5 2.5 0 0 0-.865-1.465 2.53 2.53 0 0 0-1.61-.574m-.532 1.858a.859.859 0 0 1 1.082.002c.146.12.25.29.286.486l.493 2.628-2.62.025.473-2.656a.83.83 0 0 1 .286-.485",
    clipRule: "evenodd"
  }));
};
export var ZipFile = function ZipFile(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ZipFileSvg
  }));
};